import axios from "axios"
const instance = axios.create({
	baseURL: "https://api2.cms.riesun.cn/api",
	timeout: 30000,
	headers: {
		'tenant': '209847',
	}
})

instance.interceptors.request.use((config) => {
	return config;
})
instance.interceptors.response.use((response) => {
	return Promise.resolve(response.data)
})

export default instance;